module.exports = __webpack_public_path__ + "static/dcom1-1024x908-a541b845513f7f1eaa2dffd645265171.png";